export const classes = {
  wrapper:
    'flex justify-between px-4 py-2 border-b border-grey-3 dark:border-white/10',
  stepControls: 'flex items-center',
  resetButton:
    'text-grey-7 dark:text-mauve-2 hover:text-grey-8 dark:hover:text-mauve-1 font-normal text-base ml-4 mr-6 px-4',
};
